'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../i-bem/i-bem.react');

var _eMain = (require('./__main/header2__main.react.js').default || require('./__main/header2__main.react.js')).applyDecls();

var _eMain2 = _interopRequireDefault(_eMain);

var _eLeft = (require('./__left/header2__left.react.js').default || require('./__left/header2__left.react.js')).applyDecls();

var _eLeft2 = _interopRequireDefault(_eLeft);

var _eRight = (require('./__right/header2__right.react.js').default || require('./__right/header2__right.react.js')).applyDecls();

var _eRight2 = _interopRequireDefault(_eRight);

var _eGap = (require('./__gap/header2__gap.react.js').default || require('./__gap/header2__gap.react.js')).applyDecls();

var _eGap2 = _interopRequireDefault(_eGap);

var _eLogoMSizeM = (require('./__logo/header2__logo.react.js').default || require('./__logo/header2__logo.react.js')).applyDecls();

var _eLogoMSizeM2 = _interopRequireDefault(_eLogoMSizeM);

var _eParanja = (require('./__paranja/header2__paranja.react.js').default || require('./__paranja/header2__paranja.react.js')).applyDecls();

var _eParanja2 = _interopRequireDefault(_eParanja);

var _eUnder = (require('./__under/header2__under.react.js').default || require('./__under/header2__under.react.js')).applyDecls();

var _eUnder2 = _interopRequireDefault(_eUnder);

var _eProgress = (require('./__progress/header2__progress.react.js').default || require('./__progress/header2__progress.react.js')).applyDecls();

var _eProgress2 = _interopRequireDefault(_eProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'header2',
    mods: function mods(_ref) {
        var fixed = _ref.fixed,
            panels = _ref.panels,
            border = _ref.border;

        return {
            fixed: this.__self.bool2string(!!fixed),
            panels: this.__self.bool2string(!!panels),
            border: border
        };
    },
    content: function content(_ref2) {
        var logo = _ref2.logo,
            left = _ref2.left,
            right = _ref2.right,
            children = _ref2.children;

        return children ? children : _react2.default.createElement(
            _eMain2.default,
            { key: 'main' },
            logo,
            _react2.default.createElement(
                _eLeft2.default,
                null,
                left
            ),
            _react2.default.createElement(
                _eRight2.default,
                null,
                right
            )
        );
    }
}, {
    Main: _eMain2.default,
    Left: _eLeft2.default,
    Right: _eRight2.default,
    Logo: _eLogoMSizeM2.default,
    Paranja: _eParanja2.default,
    Under: _eUnder2.default,
    Gap: _eGap2.default,
    Progress: _eProgress2.default
});